import { Button, ModalProps, Typography } from 'antd';
import { useEffect, useRef, useState } from 'react';
import UserGroupUpdateUsersForm, { UserGroupUpdateUsersFormRefProps } from './UserGroupUpdateUsersForm';
import { messages, userGroupsMessages } from 'messages';
import { Modal } from 'components/common';

type UpdateUserModalProps = ModalProps & {
  userGroupId?: number;
  onClose?: () => void;
};

const UpdateUserModal = ({ userGroupId, onClose, ...props }: UpdateUserModalProps) => {
  const [loading, setLoading] = useState(false);

  const userStatusFormRef = useRef<UserGroupUpdateUsersFormRefProps>(null);

  useEffect(() => {
    if (!props.open && userStatusFormRef.current) {
      userStatusFormRef.current.form.resetFields();
    }
  }, [props.open, userStatusFormRef.current]);

  return (
    <Modal.Headless
      {...props}
      classNames={{ content: 'bg-colorBgBody' }}
      maskClosable={false}
      centered
      destroyOnClose
      footer={[
        <Button
          key='btn-submit'
          loading={loading}
          onClick={() => {
            if (userStatusFormRef.current) {
              userStatusFormRef.current.form.submit();
            }
          }}
          size='large'
          type='primary'
        >
          {messages.saveButtonText}
        </Button>
      ]}
      title={userGroupsMessages.updateUsers}
    >
      {userGroupId && (
        <UserGroupUpdateUsersForm
          userGroupId={userGroupId}
          onChangeSuccess={onClose}
          ref={userStatusFormRef}
          onChangeLoading={setLoading}
        />
      )}
    </Modal.Headless>
  );
};

export default UpdateUserModal;
